import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InteractionApiService} from "../../api/interaction-api.service";
import {UserInteractionDto, UserInteractionTypeDto} from "../../types/ds-interaction.types";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {
  InteractionButtons,
  InteractionService,
  InteractionServiceStep,
  InteractionSubjectData
} from "../../service/interaction.service";

import { Location } from '@angular/common';
import {Subscription} from "rxjs";
import {AppMessageService} from "../../../core/service/app-message.service";


@Component({
  selector: 'app-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['interaction.component.scss']
})
export class InteractionComponent extends CoreComponent implements OnInit {

  interactionType?: UserInteractionTypeDto | null;
  interaction?: UserInteractionDto | null;

  displayContinue?: boolean;
  displayPrevious?: boolean;

  protected interactionSubscription?: Subscription;
  protected buttonsSubscription?: Subscription;
  protected busySubscription?: Subscription;

  protected interactionData?: InteractionSubjectData;
  protected buttonsData?: InteractionButtons;

  constructor(
    protected interactionService: InteractionService,
    private route: ActivatedRoute,
    protected router: Router,
    protected messageService: AppMessageService,
    private location: Location) {
    super();
  }


  override ngOnInit() {

    super.ngOnInit();

    // observe new interaction data and react based on it
    this.interactionSubscription = this.interactionService.interactionSubject.subscribe(value => {
      this.interactionData = value;
      this.initialized = true;

      // we'll adjust the URL without the subscribers being informed
      if (this.interactionData.type && this.interactionData.step && this.interactionData.interaction) {
        this.router.navigate([`/ci/service/${this.interactionData.type.id}/${this.interactionData.step}/${this.interactionData.interaction.id}`]);
      } else if (this.interactionData.type && this.interactionData.step) {
        this.router.navigate([`/ci/service/${this.interactionData.type.id}/${this.interactionData.step}`]);
      } else if (this.interactionData.type) {
        this.router.navigate([`/ci/service/${this.interactionData.type.id}`]);
      }

    });

    // derive buttons data
    this.buttonsSubscription = this.interactionService.buttonsSubject.subscribe(value => {
      this.buttonsData = value;
    });

    this.busySubscription = this.interactionService.busySubject.subscribe(value => {
      this.busy = value;
    });



    // handle route changes (including route changes triggered by the component itself)
    this.route.paramMap.subscribe(params => {

      let interactionTypeId = params.get('typeId');
      const step: InteractionServiceStep = params.get('step') as InteractionServiceStep;
      const interactionId = params.get('interactionId');

      if (interactionTypeId && interactionId && step) {

        // continue interaction with all paramaters
        this.interactionService.continueInteraction(+interactionTypeId, step, +interactionId);

      } else if (interactionTypeId && step) {

        // continue interaction with all paramaters
        this.interactionService.continueInteraction(+interactionTypeId, step);

      } else if (interactionTypeId) {

        // continue interaction with all paramaters
        if (interactionTypeId == "contactUs") {
          this.interactionService.continueInteraction(interactionTypeId);
        } else {
          this.interactionService.continueInteraction(+interactionTypeId);
        }


      }else {

        console.error("interactionComponent: Wrong routing!");
        this.router.navigate([`/ci/services`]);
      }


    });
  }

  handleNextStep() {
    this.interactionService.raiseEvent("next");
  }

  handlePreviousStep() {
    this.interactionService.raiseEvent("previous");
  }

  handleFinalize() {
    this.interactionService.raiseEvent("finalize");
  }


}
